// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"login_loading_background__5zAH0","loading_img":"login_loading_img__38VcY","svg":"login_svg__3CSpE"};